import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Experience Data with logos
const experiences = [
  {
    title: "Mobile Application Developer",
    company: "Aga Khan University",
    logo: require('../assets/Company/1.jpg'),
    type: "Full-time",
    date: "Jul 2025 - Present",
    location: "On-site",
    description: [
      "Driving innovation at the intersection of AI, digital health, and education by building scalable solutions for global health initiatives.",
      "🔹 HPV Vaccine Campaign – AI Voice Agent for Public Health: Partnered with Aga Khan University Hospital, Gates Foundation, Viamo, IBEX, and the Government of Pakistan to develop an AI-powered voice agent for HPV vaccination awareness. Implemented NLP-driven sentiment analysis and large-scale data analytics to understand public perception. Built multilingual AI voice pipelines and contributed to securing $250K+ funding.",
      "🔹 AI-DLPI (AI-Driven Digital Learning Platform for Immunization): Leading AI development of a mobile digital learning platform for vaccinators and healthcare professionals. Designed AI-powered voice assistants, chatbots, and course recommendation systems. Collaborated with WHO, UNICEF, and global partners to secure $500K+ in project funding."
    ],
    skills: ["React Native", "Node.js", "Flask", "AI/ML", "RAG", "Sentiment Analysis", "MongoDB"]
  },
  {
    title: "AI Engineer",
    company: "Gates Foundation",
    logo: require('../assets/Company/2.jpg'),
    type: "Full-time",
    date: "Jun 2025 - Present",
    location: "On-site",
    description: [
      "Contributing to AI-driven public health projects."
    ],
    skills: ["AI/ML", "NLP", "Data Analytics"]
  },
  {
    title: "Software Developer",
    company: "NCL - NED",
    logo: require('../assets/Company/3.jpg'),
    type: "Full-time",
    date: "Oct 2023 - Jun 2025",
    location: "Karāchi, Sindh, Pakistan · On-site",
    description: [
      "🔹 Geospatial & Real-Time Systems (SUPARCO Collaboration): Developed scalable web apps using React, Node.js, Flask within Microservices/MVC architectures. Built interactive mapping with LeafletJS & React, designed prototypes in Figma, implemented UI with TailwindCSS. Integrated real-time data acquisition via UART & CANBUS. Managed backend with SQL databases and deployed containerized services using Docker.",
      "🔹 AI-Powered Traffic Control (Smart City Project): Designed YOLOv7-tiny models for real-time vehicle detection and traffic optimization. Built custom traffic control algorithms on Arduino Portenta, communicated with Jetson Nano via Wi-Fi/API. Applied edge computing + AI/ML frameworks to optimize real-time decision-making."
    ],
    skills: ["React", "Node.js", "Flask", "Docker", "YOLO", "IoT"]
  },
  {
    title: "Artificial Intelligence Intern",
    company: "NCAI - NEDUET, Smart City Lab",
    logo: require('../assets/Company/4.png'),
    type: "Internship",
    date: "Aug 2023 - Oct 2023",
    location: "Karāchi, Sindh, Pakistan · On-site",
    description: [
      "Implemented and optimized YOLOv5 and Faster R-CNN models for real-time object detection in smart city applications.",
      "Collaborated with engineers and researchers, applying AI to urban planning and infrastructure challenges."
    ],
    skills: ["YOLOv5", "Faster R-CNN", "Python", "Machine Learning"]
  }
];

const ExperienceSection = () => {
  const [openIndex, setOpenIndex] = useState(0); // First card open by default

  const toggleCard = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="experience" className="experience-section text-gray-300 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white text-center">Experience</h2>

        <div className="flex flex-col gap-6">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              className="bg-black/70 p-4 md:p-6 rounded-xl border border-gray-800 shadow-lg cursor-pointer hover:shadow-xl transition-shadow"
              layout
              onClick={() => toggleCard(index)}
            >
              <div className="flex items-center gap-4">
                <img
                  src={exp.logo}
                  alt={exp.company}
                  className="w-12 h-12 object-contain rounded-md"
                />
                <div className="flex-1">
                  <h3 className="text-xl md:text-2xl font-semibold text-white">{exp.title}</h3>
                  <p className="text-gray-400">
                    <span className="font-medium text-blue-400">{exp.company}</span> · {exp.type}
                  </p>
                  <p className="text-gray-500 text-sm">{exp.date} · {exp.location}</p>
                </div>
                <span className="text-gray-400 text-2xl">{openIndex === index ? "−" : "+"}</span>
              </div>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    className="mt-4 text-gray-300"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                  >
                    {exp.description.map((desc, i) => (
                      <p key={i} className="mb-2 leading-relaxed">{desc}</p>
                    ))}

                    <ul className="flex flex-wrap gap-2 mt-3">
                      {exp.skills.map((skill, i) => (
                        <li key={i} className="bg-blue-500 text-black text-xs font-medium px-2 py-1 rounded">
                          {skill}
                        </li>
                      ))}
                    </ul>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
